import Component from '@glimmer/component';

import CommonShareLinkComponent from 'webapp/components/common/share/link/index';

import type Report from 'webapp/models-custom/report';

export interface Args {
	model: Report;
	isContentShown: boolean;
	trackingOrigin: string; // TrackingOriginTypeForShare from model-manager/reports
	onContentChange: () => void;
	onClose: () => void;
}

// eslint-disable-next-line ember/no-empty-glimmer-component-classes
export default class ReportsShareLinkTabComponent extends Component<Args> {
	<template>
		<div class="content2 {{if @isContentShown 'content2--shown'}} shareable-link">

			<CommonShareLinkComponent
				@model={{@model}}
				@trackingOrigin={{@trackingOrigin}}
				@onContentChange={{@onContentChange}}
			/>

		</div>
	</template>
}
